import moment from 'moment';
import { forwardRef, useEffect, useState } from 'react';
import Moment from 'react-moment';
import { apiService } from '../../api/axiosClient';

const bodyStyle = {
    margin: "40px"
}
const tableStyle = {
    margin: '0 auto',
    borderCollapse: 'collapse',
    width: '870px'
}
const tdStyleHeader = {
    color: '#333',
    padding: '0',
    font: 'bold 10px dotum',
    textAlign: 'right'
}
const tdStyleBig = {
    color: '#333',
    padding: '15px',
    font: 'bold 30px dotum',
    textAlign: 'center'
}
const basicStyle = {
    padding: '8px',
    font: 'bold 12px dotum',    
    border: '1px solid #ddd'
}
const tdStyle1 = {
    ...basicStyle,
    backgroundColor: '#f9f9f9'
}
const tdStyle2 = {
    ...basicStyle,
    textAlign: 'left',
}
const tdStyle3 = {
    ...basicStyle,
    textAlign: 'center'
}
const tdStyle4 = {
    ...tdStyle2,
    border: 'none'
}
const tdStyle5 = {
    padding: '8px',
    font: 'bold 12px dotum'
}
const tdStyle6 = {
    ...tdStyle2,
    textAlign: 'right',
}

const currencyLocale = Intl.NumberFormat('ko-KR');

const PrintSpecForm = forwardRef((props, ref) => {
    const {malls, list} = props;
    const [staff, setStaff] = useState(null);
    const sum = list.reduce((partialSum, a) => partialSum + a.sprice, 0);
    const member = {
        com_name: list[0].com_name,
        com_id: list[0].com_id,
        name: list[0].uname,
        phone: list[0].phone,
        email: list[0].email
    };

    useEffect(() => {
        const getStaff = async (comId) => {
            try {
                const response = await apiService.get(`/staff/company/${comId}`);
                const payload = response.data;
                setStaff(payload.data);
            } catch (error) {
                console.error('Error loading staff:', error);
            }
        }

        member.com_id && getStaff(member.com_id);
    }, []);

    return (
        <div style={bodyStyle} ref={ref}>
            <style>
                {`
                    @media print {
                        html, body {
                            height: initial !important;
                            overflow: initial !important;        
                            -webkit-print-color-adjust: exact;
                        }                    
                        .prt-spec-table {
                            width: 100%;
                        }
                    }
                `}
            </style>
            <table style={tableStyle}>
                <tbody>
                    <tr>
                        <td rowSpan={3} colSpan={3} style={{padding: '0'}}>
                            <img src='/images/logo.png' alt="logo" width="145" height="50" />
                        </td>
                        <td colSpan={6} style={tdStyleHeader}>https://www.aladdinsci.net</td>
                    </tr>
                    <tr>
                        <td colSpan={6} style={tdStyleHeader}>주소: {malls.address}</td>
                    </tr>
                    <tr>
                        <td colSpan={6} style={tdStyleHeader}>TEL: {malls.tel}</td>
                    </tr>
                    <tr>
                        <td colSpan={9} style={tdStyleBig}>견적서</td>
                    </tr>
                    <tr>
                        <td colSpan={9} style={tdStyle5}>&nbsp;</td>
                    </tr>
                    <tr>
                        <th colSpan={1} width="16%" style={tdStyle1}>견적번호</th>
                        <td colSpan={3} width="48%" style={tdStyle2}>{moment().format('YYMMDDhhmmss')}</td>
                        <th colSpan={1} width="16%" style={tdStyle1}>사업자번호</th>
                        <td colSpan={4} width="48%" style={tdStyle2}>{malls.license_num}</td>
                    </tr>
                    <tr>
                        <th colSpan={1} style={tdStyle1}>견적일자</th>
                        <td colSpan={3} style={tdStyle2}><Moment format="YYYY년 MM월DD일">{moment()}</Moment></td>
                        <th rowSpan={2} colSpan="1" style={tdStyle1}>상호</th>
                        <td rowSpan={2} colSpan="4" style={tdStyle2}>
                            <img src="/images/stamp_company.png" alt="상호" />
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={1} style={tdStyle1}>소속기관명</th>
                        <td colSpan={3} style={tdStyle2}>{member?.com_name}</td>
                    </tr>
                    <tr>
                        <th colSpan={1} style={tdStyle1}>견적요청인</th>
                        <td colSpan={3} style={tdStyle2}>{member?.name}</td>
                        <th colSpan={1} style={tdStyle1}>업태</th>
                        <td colSpan={4} style={tdStyle2}>제조업, 도소매, 서비스업</td>
                    </tr>
                    <tr>
                        <th colSpan={1} style={tdStyle1}>휴대전화번호</th>
                        <td colSpan={3} style={tdStyle2}>{member?.phone}</td>
                        <th rowSpan={2} colSpan="1" style={tdStyle1}>종목</th>
                        <td rowSpan={2} colSpan="4" style={tdStyle2}>기타 기초무기화합물 제조업<br/>실험검사용 시약, 과학기자재 도소매업</td>
                    </tr>
                    <tr>
                        <th colSpan={1} style={tdStyle1}>이메일주소</th>
                        <td colSpan={3} style={tdStyle2}>{member?.email}</td>
                    </tr>
                    <tr>
                        <th colSpan={1} style={tdStyle1}>결제조건</th>
                        <td colSpan={3} style={tdStyle2}>
                            선결제 (학교, 국가 연구소, 계약업체 제외)<br/>결제계좌 {malls.bank_name}<br/>{malls.bank_account}
                        </td>
                        <th colSpan={1} style={tdStyle1}>영업담당</th>
                        <td colSpan={4} style={tdStyle2}>
                            {staff?.username || "sales"}<br/>&#9755; <a href={`mailto:`}>{staff?.email || "sales@aladdinsci.net"}</a>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={9} style={tdStyle5}>&nbsp;</td>
                    </tr>
                    <tr>
                        <th width="15%" style={tdStyle1}>Item No.</th>
                        <th width="15%" style={tdStyle1}>품명</th>
                        <th width="10%" style={tdStyle1}>CAS No.</th>
                        <th width="20%" style={tdStyle1}>규격</th>
                        <th width="8%"  style={tdStyle1}>납기</th>
                        <th width="8%"  style={tdStyle1}>용량</th>
                        <th width="8%"  style={tdStyle1}>수량</th>
                        <th width="8%"  style={tdStyle1}>단가</th>
                        <th width="8%"  style={tdStyle1}>합계</th>
                    </tr>
                    {
                        list.map((item, index) =>
                            <tr key={index}>
                                <td width="15%" style={tdStyle3}>{item.cat_id}</td>
                                <td width="15%" style={tdStyle3}>{item.name}</td>
                                <td width="10%" style={tdStyle3}>{item.pd_cas}</td>
                                <td width="20%" style={tdStyle3}>{item.spec_desc}</td>
                                <td width="8%"  style={tdStyle3}><Moment format="YYYY년 MM월DD일">{moment().add(item.pd_lead, 'd')}</Moment></td>
                                <td width="8%"  style={tdStyle3}>{item.pd_packing}</td>
                                <td width="8%"  style={tdStyle3}>{item.qty}</td>
                                <td width="8%"  style={tdStyle3}>{currencyLocale.format(item.cprice)}</td>
                                <td width="8%"  style={tdStyle3}>{currencyLocale.format(item.sprice)}</td>
                            </tr>
                        )
                    }
                    <tr>
                        <td colSpan={9} style={tdStyle5}>&nbsp;</td>
                    </tr>                    
                    <tr>
                        <td rowSpan={4} colSpan="3"></td>
                        <td colSpan={2} style={tdStyle4}>&nbsp;</td>
                        <th colSpan={2} style={tdStyle1}>총금액</th>
                        <td colSpan={2} style={tdStyle6}>{currencyLocale.format(sum)} 원</td>
                    </tr>
                    <tr>
                        <td colSpan={2} style={tdStyle4}>&nbsp;</td>
                        <th colSpan={2} style={tdStyle1}>부가세</th>
                        <td colSpan={2} style={tdStyle6}>{currencyLocale.format(sum * 0.1)} 원</td>
                    </tr>
                    <tr>
                        <td colSpan={2} style={tdStyle4}>&nbsp;</td>
                        <th colSpan={2} style={tdStyle1}>베송비</th>
                        <td colSpan={2} style={tdStyle6}>0 원</td>
                    </tr>
                    <tr>
                        <td colSpan={2} style={tdStyle4}>&nbsp;</td>
                        <th colSpan={2} style={tdStyle1}>총합계</th>
                        <td colSpan={2} style={tdStyle6}>{currencyLocale.format(sum * 1.1)} 원</td>
                    </tr>
                    <tr>
                        <td colSpan={9} style={tdStyle5}>&nbsp;</td>
                    </tr>
                    <tr>
                        <td colSpan={9} style={tdStyle5}>&nbsp;&#9673; 세금계산서는 제품이 출고되는 시점에 발행됩니다.</td>
                    </tr>
                    <tr>
                        <td colSpan={9} style={tdStyle5}>&nbsp;&#9673; 평일 오후 3시 이후 결제 확인시 납기가 하루 더 소요됩니다.</td>
                    </tr>
                    <tr>
                        <td colSpan={9} style={tdStyle5}>&nbsp;&#9673; 법정 공휴일 전날과 금요일에는 냉동/냉장 포장 제품의 출고가 없습니다.</td>
                    </tr>
                    <tr>
                        <td colSpan={9} style={{padding: '10px'}}>&nbsp;</td>
                    </tr>
                </tbody>                
            </table>
        </div>
    );
});

export default PrintSpecForm